import React from 'react';

const ErrorMessage = ({ message }) => {
    return <div className="error-message">{message}</div>;
};
export default ErrorMessage
